// frontend/src/helpers/sourceMiniGamesImages.js
export const sourceImages = require.context('../assets/images/miniGames', true);